module.exports = __webpack_public_path__ + "static/assets/0813b98f87ce7d9838545583ecc0e41b.svg";